import { Label, P } from '@kizi/core-components';
import {
  ModalWithStepsWrapper,
  ModalWithStepsWrapperProps,
} from '@kizi/comparator-components';
import React from 'react';

export const CombinationDiscount: React.FC<ModalWithStepsWrapperProps> = ({
  ...modalProps
}) => {
  return (
    <>
      <Label variant="heading">Combinatiekorting</Label>
      <P my="2" variant="footnoteRegular">
        Combineer je abonnementen van één aanbieder en krijg extra korting.
      </P>
      <ModalWithStepsWrapper {...modalProps} />
    </>
  );
};
